import { createAuthClient } from "better-auth/react";
import { convexClient } from "@convex-dev/better-auth/client/plugins";

/**
 * Better Auth client. Requests go to the first-party /api/auth/* routes
 * (app/api/auth/[...all]/route.ts), which proxy to the Convex deployment —
 * so session cookies live on our own origin.
 */
export const authClient = createAuthClient({
  plugins: [convexClient()],
});
